import { $ } from 'base/bootstrap';

$(document).ready(function () {
    let currentForm;

    function removeModalBackdrop() {
        $('.modal-backdrop').remove();
        $('body').removeClass('modal-open');
        $('body').css('padding-right', '');
    }

    function showLoadingAnimation() {
        $('body').append(
            '<div id="fullscreenLoader" class="position-fixed w-100 h-100 d-flex justify-content-center align-items-center" style="top: 0; left: 0; background: rgba(255,255,255,0.7); z-index: 9999;"><div class="spinner-border text-primary" role="status" style="width: 6rem; height: 6rem; padding: 1rem;"><span class="sr-only">Loading...</span></div></div>'
        );
    }

    function hideLoadingAnimation() {
        $('#fullscreenLoader').remove();
    }

    $('.btn-play-bundle').on('click', function (e) {
        e.preventDefault();
        const $button = $(this);

        if ($button.data('login-url')) {
            window.location.href = $button.data('login-url');
        } else {
            currentForm = $button.closest('form');
            $('#bundleName').text($button.data('bundle-name'));
            $('#confirmPurchaseModal').modal('show');
        }
    });

    $('#confirmPurchase').on('click', function () {
        if (currentForm) {
            $('#confirmPurchaseModal').modal('hide');
            removeModalBackdrop();
            showLoadingAnimation();

            // Submit the form after a short delay
            setTimeout(function () {
                currentForm.submit();
            }, 500);
        }
    });

    // Additional cleanup
    $(document).on('click', '.modal-backdrop', function () {
        removeModalBackdrop();
    });

    function adjustOverlayHeight() {
        $('.bundle-lotteries-overlay').each(function () {
            const $overlay = $(this);
            const $container = $overlay.closest('.bundle-image-container');
            const containerHeight = $container.height();
            const contentHeight = $overlay.find('.overlay-content').outerHeight();

            if (contentHeight < containerHeight * 0.4) {
                $overlay.css('height', '40%');
            } else if (contentHeight > containerHeight * 0.8) {
                $overlay.css('height', '80%');
            } else {
                $overlay.css('height', 'auto');
            }
        });
    }

    adjustOverlayHeight();
    $(window).on('resize', adjustOverlayHeight);
});

function updateCountdown() {
    $('.countdown').each(function () {
        const $this = $(this);
        const expiresAt = new Date($this.data('expires')).getTime();
        const now = new Date().getTime();
        const difference = expiresAt - now;

        if (difference < 0) {
            $this.html('{{ _i("Offer expired") }}');
            return;
        }

        const days = Math.floor(difference / (1000 * 60 * 60 * 24));
        const hours = Math.floor((difference % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
        const minutes = Math.floor((difference % (1000 * 60 * 60)) / (1000 * 60));
        const seconds = Math.floor((difference % (1000 * 60)) / 1000);

        $this.find('.days').text(days);
        $this.find('.hours').text(hours.toString().padStart(2, '0'));
        $this.find('.minutes').text(minutes.toString().padStart(2, '0'));
        $this.find('.seconds').text(seconds.toString().padStart(2, '0'));
    });
}

updateCountdown();
setInterval(updateCountdown, 1000);
